import { toAttributes } from '@shared/shop-api/attributes/mapper'
import type { CartLineAttributes } from '@shared/shop-api/cart/lines/types'
import { toItemCost } from '@shared/shop-api/cost/mapper'
import { toProduct } from '@shared/shop-api/product/mapper'
import { toProductVariant } from '@shared/shop-api/product/variants/mapper'
import type { CartLineFragment } from '@shared/types/storefront/graphql'

export const toCartLine = (cartLine: CartLineFragment) => {
  return {
    id: cartLine.id,
    quantity: cartLine.quantity,
    cost: toItemCost(cartLine.cost, cartLine.quantity),
    variant: {
      ...toProductVariant(cartLine.merchandise),
      product: toProduct(cartLine.merchandise.product),
    },
    attributes: toAttributes<CartLineAttributes>(cartLine.attributes),
  }
}
